import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { InstallAppPayload } from '../models/post-req-responses-payloads';

export const useQueryForInstallApp = (appSubscriptionId: string): InstallAppPayload => {
  const { search } = useLocation();
  return useMemo(() => {
    let query = new URLSearchParams(search);
    return {
      redirect_uri: query.get('redirect_uri') || '',
      state: query.get('state') || '',
      response_type: query.get('response_type') || '',
      appSubscriptionId: appSubscriptionId || '',
      scope: '',
    };
  }, [search, appSubscriptionId]);
};
